import { routes } from "./symbols";

export const getWizardSteps = (data, flow) => {
	const steps = [routes.bookingForm];
	const hasPreselectedCenter = !!data.centerFromParam;

	const isParabrisas = data.damageGlass?.includes("Parabrisas");
	const hasMoreInfo =
		data.damageGlass &&
		(data.damageGlass.toLowerCase().includes("fijo") ||
			data.damageGlass.toLowerCase().includes("luneta"));

	if (flow === "mapfre") {
		steps.push(routes.intro);
		steps.push(routes.damageGlass);
		if (isParabrisas) {
			steps.push(routes.damageType);
			if (data.damageType === "small") steps.push(routes.damageArea);
		} else if (hasMoreInfo) {
			steps.push(routes.damageGlassMoreInfo);
		}
		steps.push(routes.selectDateTime);
		steps.push(routes.loader);
	} else if (data.journey === "B") {
		steps.push(routes.damageGlass);
		if (isParabrisas) {
			steps.push(routes.damageType);
			if (data.damageType === "small") steps.push(routes.damageArea);
		} else if (hasMoreInfo) {
			steps.push(routes.damageGlassMoreInfo);
		}
		if (!hasPreselectedCenter) steps.push(routes.selectCenter);
		steps.push(routes.selectDateTime);
		steps.push(routes.bookingEnd);
		steps.push(routes.thankYouPage);
	} else {
		steps.push(routes.damageGlass);
		if (isParabrisas) {
			steps.push(routes.damageType);
			if (data.damageType === "small") steps.push(routes.damageArea);
		} else if (hasMoreInfo) {
			steps.push(routes.damageGlassMoreInfo);
		}
		if (!hasPreselectedCenter) steps.push(routes.selectCenter);
		steps.push(routes.selectDateTime);
		steps.push(routes.bookingEnd);
		steps.push(routes.thankYouPage);
	}

	return steps;
};
